import { render, staticRenderFns } from "./Bannerswitch.vue?vue&type=template&id=2fa46bae&scoped=true&"
import script from "./Bannerswitch.vue?vue&type=script&lang=js&"
export * from "./Bannerswitch.vue?vue&type=script&lang=js&"
import style0 from "./Bannerswitch.vue?vue&type=style&index=0&id=2fa46bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa46bae",
  null
  
)

export default component.exports